import React, { useEffect } from "react";

import { Grid } from "@mui/material";
import { useContentSize } from "containers/hooks/useWindowSize";
import { setSidebarFilter } from "@store/filters/actions";
import { FilterType } from "@store/filters/types";
import { useAppDispatch, useAppSelector } from "index";
import { setCurrentVisualization } from "@store/options/actions";
import { VisTypes } from "@store/options/types";
import BarChart from "containers/Visuals/BarChart";
import useTranslations from "containers/hooks/useLanguageHook";
import { VisPageWrapper } from "@pages/VisPageWrapper";
import { calculateGridItemSize } from "@utils/format";
import { GridSize } from "@mui/material/Grid";
import MultipleViewTitleGrid from "../Components/MultipleViewTitleGrid";
import { getProvider } from "../../fileParsing/definitions";
import { switchActive } from "@store/data/actions";
import { ApplicationState } from "@store/index";
const BarChartImage = new URL("../../../public/barchart.png", import.meta.url).href;

function BarchartPage() {
  const { width, height } = useContentSize();
  const { t } = useTranslations();
  const dispatch = useAppDispatch();

  const options = useAppSelector((state: ApplicationState) => state.options.options);
  const providerItems = useAppSelector((state: ApplicationState) => state.data.exports);

  const activeExports = providerItems.filter((d) => d.active);

  useEffect(() => {
    dispatch(setSidebarFilter([FilterType.categories]));
    dispatch(setCurrentVisualization(VisTypes.Barchart));
  }, [dispatch]);

  return (
    <VisPageWrapper
      title={t.Vis.Barchart}
      help={{
        title: t.LandingPage.BarChartTitle,
        description: t.LandingPage.BarChartText,
        image: BarChartImage,
      }}
    >
      {options.MultipleViews.value && activeExports.length > 1 ? (
        <Grid container spacing={1}>
          {activeExports.map((d, i, list) => (
            <Grid item xs={calculateGridItemSize(list.length) as GridSize} key={d.id}>
              <MultipleViewTitleGrid
                fileName={d.fileProperties.fileName}
                providerName={d.providerId === "wrangled" ? t.DataPage.UnknownProvider : getProvider(d.providerId).name}
                handleHide={() => dispatch(switchActive(d.id))}
              />
              <BarChart
                exportIds={[d.id]}
                size={{
                  width,
                  height: height / 2 - 28,
                }}
              />
            </Grid>
          ))}
        </Grid>
      ) : (
        <BarChart
          size={{
            width,
            height,
          }}
        />
      )}
    </VisPageWrapper>
  );
}

export { BarchartPage };
